export const halfSecondDelay = {delay: 500};
export const forwardState = ({delay} = {delay: 0}) => ({stateManager: {nextState}}) => nextState(delay)
